'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { SlidersHorizontal } from 'lucide-react';
import ListFilterSidebar from './ListFilterSidebar';
import { cn } from '@/lib/utils';
import { JSX } from 'react';

interface MobileFilterDrawerProps {
  className?: string;
}

export default function MobileFilterDrawer({ className }: MobileFilterDrawerProps): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className={cn('flex items-center gap-1.5 md:hidden h-10', className)}
        >
          <SlidersHorizontal className="h-4 w-4" />
          <span>Filters</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[300px] sm:w-[350px] p-4 overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Filters</SheetTitle>
        </SheetHeader>
        <ListFilterSidebar isMobile={true} onMobileClose={() => setOpen(false)} className="mt-4" />
      </SheetContent>
    </Sheet>
  );
}
